var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var blue = designTokens.color.blue.default.value;
var red = designTokens.color.red.default.value;
var black = designTokens.color.shade.black.value;
var themeOptions = function () { return ({
    components: {
        MuiListItem: {
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.uiTextSmall), { lineHeight: '1.285', cursor: 'pointer', borderRadius: '4px', outline: 'none', padding: '7px 8px', gap: '8px', minHeight: '36px', margin: '0 8px', width: 'calc(100% - 16px)', '&.hyperlink': {
                        '&:hover, &:focus': {
                            background: "".concat(blue, "0C"),
                        },
                        '&:active': {
                            background: "".concat(blue, "19"),
                        },
                        color: "".concat(blue),
                    }, '&.destructive': {
                        '&:hover, &:focus': {
                            background: "".concat(red, "0C"),
                        },
                        '&:active': {
                            background: "".concat(red, "19"),
                        },
                        color: "".concat(red),
                    }, '&.default': {
                        color: "".concat(black),
                        '&:hover, &:focus': {
                            background: "".concat(blue, "0C"),
                            color: "".concat(blue),
                        },
                        '&:active': {
                            background: "".concat(blue, "19"),
                            color: "".concat(blue),
                        },
                    }, '& .MuiSvgIcon-root': {
                        fontSize: '1.25rem',
                    } }),
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=listItemTheme.js.map